import React, { useContext } from 'react'
import NavbarTop from '../components/navbar/NavbarTop'
import NavbarVertical from '../components/navbar/NavbarVertical'
import Footer from '../components/footer/Footer'
import Breadcrumbs from '../components/common/Breadcrumbs'
import AppContext from '../context/Context'
import ProviderRoutes from '../routes/ProviderRoutes'

const ProviderLayout = () => {
  const { isFluid, isTopNav } = useContext(AppContext)

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      {!isTopNav && <NavbarVertical />}
      <div className="content">
        <NavbarTop />
        <Breadcrumbs />
        <ProviderRoutes />
        <Footer />
      </div>
    </div>
  )
}

export default ProviderLayout
